var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundPreview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 625,
    height: 266,
    viewBox: "0 0 625 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M505.656 16.1513C515.379 10.3971 549.907 28.6636 563.249 34.8853C576.592 41.1071 617.731 60.2907 617.956 68.5174C618.181 76.744 591.445 142.788 576.328 151.983C569.288 155.468 533.633 136.135 521.402 130.432C509.172 124.729 466.402 106.138 464.547 98.505C462.692 90.8717 489.621 25.865 505.656 16.1513Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M484.656 27.1507C494.379 21.3965 528.907 39.663 542.249 45.8847C555.592 52.1064 596.731 71.2901 596.956 79.5168C597.181 87.7434 570.445 153.788 555.328 162.982C548.288 166.468 512.633 147.134 500.402 141.431C488.172 135.728 445.402 117.138 443.547 109.504C441.692 101.871 468.621 36.8644 484.656 27.1507Z",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M495.032 25.2208C504.754 19.4667 539.283 37.7332 552.625 43.9549C565.968 50.1766 607.107 69.3603 607.332 77.5869C607.557 85.8136 580.821 151.858 565.704 161.053C558.664 164.538 523.009 145.205 510.778 139.501C498.548 133.798 455.778 115.208 453.923 107.575C452.068 99.9413 478.997 34.9346 495.032 25.2208Z",
    fill: "#E86E4D",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M492.069 27.2226C492.069 27.2226 509.571 65.1642 531.665 90.3568C531.665 90.3568 581.439 86.0879 607.14 78.5799",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M565.704 161.052C565.704 161.052 548.967 104.923 547.643 88.6029",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M519.617 75.2632C519.617 75.2632 473.695 97.9781 454.213 108.115",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174 92.4999C134.473 85.18 41 48.8332 -0.5 29.4999L0 159.5C59.5 175 90 176 119.5 181.5C149 187 173.5 209.5 180.5 214.5C186.1 218.5 200.167 223.167 206.5 225C217.5 232.5 242.3 250 253.5 260C264.7 270 292.167 264.167 304.5 260L329 262C336.2 267.6 344.667 265.333 348 263.5H354C358.4 267.1 362.5 265 364 263.5C378.5 263.5 413.3 263 436.5 261C459.7 259 476.167 251.167 481.5 247.5C489 243 501.9 246.5 497.5 232.5C493.1 218.5 470.333 222 459.5 225.5C463 223.167 470.5 218 472.5 216C475 213.5 481 207 471.5 197.5C463.9 189.9 451.667 198.333 446.5 203.5C445.167 198.167 439.6 188 428 190C411.6 193.2 398.167 206 393.5 212H385C368.6 200 345.5 197.333 336 197.5C331.2 185.9 313 184.333 304.5 185L295.5 161.5C339 186 366 190 373.5 163C379.729 140.575 340 134 314 129C304.407 125.935 284.5 121.5 270.5 111.5C230.5 65.4999 187.5 94.9999 174 92.4999Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79004 27.6451C1.79004 27.6451 161.119 93.9138 179.021 88.5407C196.923 83.1675 245.258 63.466 275.692 115.406",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M256 92.1228C266.741 101.078 275.692 117.197 324.027 126.153C372.363 135.108 377.734 145.854 372.363 161.974C366.992 178.093 343.72 176.302 329.398 172.72C315.076 169.138 295.384 156.6 295.384 156.6",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M304.335 179.884C304.335 179.884 293.594 149.436 286.433 138.69",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M288.224 185.257C288.224 185.257 302.545 174.511 325.818 183.466C336.559 187.048 340.14 201.377 340.14 201.377",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M336.559 192.78C361.622 192.959 380.598 203.526 386.506 207.287",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M445.762 196.003C445.762 196.003 443.972 185.257 429.65 185.257C415.328 185.257 395.636 203.168 393.846 206.75C393.846 206.75 375.944 206.75 365.203 213.914C365.203 213.914 350.881 204.959 331.189 212.123C311.496 219.287 313.287 226.451 313.287 226.451",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M331.725 211.764C331.725 211.764 324.027 201.376 302.545 199.585C281.062 197.794 272.111 212.123 272.111 212.123",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M263.161 183.466C263.161 183.466 280.168 192.063 283.211 202.988",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M191.552 110.033C191.552 110.033 205.874 111.824 236.307 149.436C257.79 179.884 279.272 179.884 279.272 179.884",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M159.328 111.824C155.748 122.57 141.426 129.735 137.846 149.436",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M204.083 93.9138C204.083 93.9138 216.615 97.4959 225.566 115.406C234.517 133.317 236.307 136.899 236.307 136.899",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M324.027 131.526C324.027 131.526 327.608 151.227 318.657 163.765",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79004 154.809C1.79004 154.809 55.4963 169.138 114.573 176.302C146.797 181.675 164.699 197.794 173.65 204.959C182.601 212.123 193.342 215.705 204.084 219.287C214.825 222.869 252.419 258.69 264.951 260.481C277.482 262.272 304.335 255.108 304.335 255.108C304.335 255.108 315.077 256.899 329.398 256.899C329.398 256.899 336.559 264.063 349.09 258.69H354.461C354.461 258.69 356.251 262.272 365.202 258.69C365.202 258.69 383.104 256.899 386.685 251.526C386.685 251.526 401.007 249.735 415.328 244.362C429.65 238.988 433.23 238.988 438.601 235.406C443.972 231.824 452.923 222.869 461.874 219.287C470.825 215.705 476.195 208.541 476.195 201.377C476.195 194.212 470.825 192.421 467.244 190.63C463.664 188.839 456.74 189.831 447.789 196.996C438.838 204.16 420.699 221.078 415.328 226.451C409.958 231.824 393.846 233.615 388.475 237.197C383.104 240.78 375.944 251.526 361.622 251.526C347.3 251.526 318.657 251.526 313.286 251.526C307.916 251.526 288.402 256.541 282.853 255.108C275.692 253.317 254.209 240.779 254.209 240.779",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M456.145 222.511C461.873 221.078 492.307 212.123 497.678 226.451C503.048 240.779 485.146 240.779 481.566 242.57C477.985 244.362 460.083 253.317 445.762 255.108C431.44 256.899 409.957 256.899 409.957 256.899C409.957 256.899 390.265 258.69 384.894 258.69C379.524 258.69 365.202 258.69 365.202 258.69",
    stroke: "#050C26",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundPreview);
export default __webpack_public_path__ + "static/media/background-preview.815e8381459205c354f6caed6a184f55.svg";
export { ForwardRef as ReactComponent };